import { useEffect, useState } from "react";
import AdminHighlightedSearchesContainer from "./AdminHighlightedSearches";

import { useAsync } from "../../../utils/hooks/useAsync";
import { carouselServices } from "../../../services/carousels";
import HighlightedMain from "./HighlightedMain";
import Loading from "../../common/Loading";
import Label from "../../Label";
import AdminHeroContainer from "./AdminHeroContainer";

const HighlightedContainer = () => {
  const { isSuccess, isLoading, run } = useAsync();
  const [carousels, setCarousels] = useState<CarouselExtended[]>();
  const [carouselMain, setCarouselMain] = useState<CarouselExtended>();
  const [carouselChain, setCarouselChain] = useState<CarouselExtended>();
  const [carouselBrazalete, setCarouselBrazalete] =
    useState<CarouselExtended>();
  const [carouselPendant, setCarouselPendant] = useState<CarouselExtended>();
  const [carouselRing, setCarouselRing] = useState<CarouselExtended>();
  const [carouselHoop, setCarouselHoop] = useState<CarouselExtended>();
  const [carouselfinding, setCarouselfinding] = useState<CarouselExtended>();
  useEffect(() => {
    run(
      carouselServices
        .getCarousels({})
        .then((data: { data: CarouselExtended[] }) => {
          setCarousels(data.data);
        })
    );
  }, []);
  useEffect(() => {
    carousels?.find((el) => el.name == "HIGHLIGHTED")?.name != undefined &&
      setCarouselMain(carousels?.find((el) => el.name == "HIGHLIGHTED"));
    carousels?.find((el) => el.name == "BRAZALETE")?.name != undefined &&
      setCarouselBrazalete(carousels?.find((el) => el.name == "BRAZALETE"));
    carousels?.find((el) => el.name == "CHAIN")?.name != undefined &&
      setCarouselChain(carousels?.find((el) => el.name == "CHAIN"));
    carousels?.find((el) => el.name == "PENDANT")?.name != undefined &&
      setCarouselPendant(carousels?.find((el) => el.name == "PENDANT"));
    carousels?.find((el) => el.name == "RING")?.name != undefined &&
      setCarouselRing(carousels?.find((el) => el.name == "RING"));
    carousels?.find((el) => el.name == "HOOP")?.name != undefined &&
      setCarouselHoop(carousels?.find((el) => el.name == "HOOP"));
    carousels?.find((el) => el.name == "FINDING")?.name != undefined &&
      setCarouselfinding(carousels?.find((el) => el.name == "FINDING"));
  }, [carousels]);

  return (
    <div className="highlightedContainer">
      <AdminHeroContainer />
      <div className="carouselsContainer">
        {isSuccess && (
          <>
            <Label
              tag="h3"
              style={{ fontFamily: "Mont-Semibold", marginBottom: "1rem" }}
            >
              Carruseles
            </Label>
            {carouselMain && <HighlightedMain carousel={carouselMain} />}
            {carouselChain && <HighlightedMain carousel={carouselChain} />}
            {carouselBrazalete && (
              <HighlightedMain carousel={carouselBrazalete} />
            )}
            {carouselPendant && <HighlightedMain carousel={carouselPendant} />}
            {carouselRing && <HighlightedMain carousel={carouselRing} />}
            {carouselHoop && <HighlightedMain carousel={carouselHoop} />}
            {carouselfinding && <HighlightedMain carousel={carouselfinding} />}
          </>
        )}
        {isLoading && <Loading />}
      </div>

      <div className="searchContainer">
        <AdminHighlightedSearchesContainer />
      </div>
    </div>
  );
};

export default HighlightedContainer;
